'use client'

import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

interface FAQItem {
  question: string
  answer: string
}

export function FAQClient({ items }: { items: FAQItem[] }) {
  // Asana 016 — all items start collapsed and only ONE may be open at a time
  // (opening an item closes the previous one; clicking the open item closes it).
  const [open, setOpen] = useState<number | null>(null)

  const toggle = (index: number) => {
    setOpen((prev) => (prev === index ? null : index))
  }

  return (
    <dl className="flex flex-col gap-4">
      {items.map((item, i) => {
        const isOpen = open === i
        const isLast = i === items.length - 1
        return (
          <div key={i} className={isLast ? '' : 'border-b border-border pb-4'}>
            <dt>
              <button
                onClick={() => toggle(i)}
                className="w-full flex gap-2 items-center text-left"
                aria-expanded={isOpen}
              >
                <span
                  className={`flex-1 min-w-0 font-display font-normal text-display-lg text-foreground ${
                    isOpen ? 'italic' : ''
                  }`}
                >
                  {item.question}
                </span>
                <ChevronDown
                  className={`flex-shrink-0 size-4 text-foreground transition-transform duration-300 ${
                    isOpen ? 'rotate-180' : ''
                  }`}
                  strokeWidth={2}
                />
              </button>
            </dt>
            <dd>
              <div
                className={`grid transition-all duration-300 ease-in-out ${
                  isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                }`}
              >
                <div className="overflow-hidden">
                  <p className="font-base font-light text-body-md text-foreground pt-4 whitespace-pre-line">
                    {item.answer}
                  </p>
                </div>
              </div>
            </dd>
          </div>
        )
      })}
    </dl>
  )
}
